module.exports = __webpack_public_path__ + "assets/google-maps.e5f72f89.svg";